(function() {
    'use strict';

    angular
        .module('telestatApp')
        .directive('profileFooter', profileFooter);

    profileFooter.$inject = ['ProfileService', '$rootScope', '$translate'];

    function profileFooter(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="footer" ng-cloak><p id="defaultFooter" class="hidden" data-translate="footer">This is your footer</p><p id="kayanFooter" class="hidden" data-translate="footerKayan">This is your footer</p></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.kayanProfile) {
                    var childs = element.children('[id=kayanFooter]');
                    childs.removeClass('hidden');
                } else {
                    var childs = element.children('[id=defaultFooter]');
                    childs.removeClass('hidden');
                }
            });
        }
    }
})();
